<template>
	<v-form
		v-model="isValid"
		@submit.prevent="submit"
	>
		<v-layout
			row
			wrap
			ma-0
			justify-center
			align-center
		>
			<v-flex
				xs12
				sm9
				py-0
			>
				<v-text-field
					v-model="label"
					:rules="[
						...validate.require,
						validate.max(label, 100)
					]"
					autofocus
					label="Label"
					
				/>
				<v-select
					v-model="type"
					:rules="[...validate.require]"
					:items="fieldTypes"
					:disabled="isEdit"
					label="Type"
				/>
			</v-flex>
			<v-flex
				xs12
				sm3
			>
				<v-btn
					:disabled="!isValid"
					ripple
					color="primary"
					type="submit"
				>
					Submit
				</v-btn>
				<v-btn
					flat
					color="error"
					@click="$emit('close')"
				>
					close
				</v-btn>
			</v-flex>
		</v-layout>
	</v-form>
</template>

<script>
import Validation from '@/mixins/Validation';
import { CustomData } from '@/models/CustomData';

export default {
	props: {
		editCustomField: {
			type: Object,
			default: null,
		},
	},
	
	mixins: [Validation],
	
	data() {
		return {
			label: '',
			type: '',
			fieldTypes: CustomData.FIELD_TYPES,
			isValid: true,
		};
	},
	
	watch: {
		editCustomField(customField) {
			if (customField) {
				this.label = customField.label;
				this.type = customField.type;
			}
		},
	},
	
	computed: {
		isEdit() {
			return Boolean(this.editCustomField);
		},
		
		project() {
			return this.$store.get('projects/currentProject');
		},
		
		customDatas() {
			return this.project.customDatas
		},
	},
	
	methods: {
		submit() {
			this.isValid = false;
			this.isEdit ? this.update() : this.create();
		},
		
		update() {
			const customField = new CustomData();
			customField.id = this.editCustomField.id;
			customField.label = this.label;
			customField.type = this.type;
			
			customField.save().then(() => {
				this.$notify('success', `Field "${customField.label}" has been updated.`);
			}).catch((e) => {
				dump(e);
				this.$notify('error', `Failed to update field "${customField.label}".`);
			}).finally(() => {
				this.refreshCustomDatas();
			});
		},
		
		create() {
			const customField = new CustomData();
			customField.set('projectId', this.project.id);
			customField.label = this.label;
			customField.type = this.type;
			
			customField.save().then(() => {
				this.$notify('success', `Field "${customField.label}" has been created.`);
			}).catch((e) => {
				dump(e);
				this.$notify('error', `Failed to create field "${customField.label}".`);
			}).finally(() => {
				this.refreshCustomDatas();
			});
		},
		
		refreshCustomDatas() {
			this.$store.dispatch('projects/loadCustomData').then().catch((e) => {
				dump(e);
				this.$notify('error', `Failed to refresh custom fields.`);
			}).finally(() => {
				this.isValid = true;
				this.$emit('close');
			});
		},
	},
}
</script>
